// extracted by mini-css-extract-plugin
module.exports = {"buttonStyle":"style_buttonStyle__ZaKzL","template1":"style_template1__Nc1I9","template2":"style_template2__6hGIM","template3":"style_template3__CGaJr"};